import 'components/select';
import QueryString from 'utils/query_string';
import './index.scss';

class QuestionSortInput {
  constructor() {
    this.$component = $('.js-question-sort');
    this.$sort = $('#sort', this.$component);
    this.sortPermissions = ['account', 'confirmed_account', 'subscription'];
    this.bindEvents();
  }

  bindEvents() {
    this.$sort.qselect('on', 'change', this.changeSort.bind(this));
  }

  checkSortPermissions() {
    const { proceed, reason } = window.permissions.hasPermissions(this.sortPermissions);

    if (proceed) {
      return true;
    }

    const myEvent = new CustomEvent(reason, {
      detail: {
        type: 'sort'
      }
    });
    this.$sort.qselect('close');
    window.permissions.feedbacks[reason](myEvent);

    if (!window.currentUser) {
      return;
    }

    UserTracker.emit('event', {
      eventName: 'account restriction reached',
      data: {
        'resource restricted': 'sort'
      }
    });

    return false;
  }

  async changeSort(value) {
    if (!this.checkSortPermissions()) {
      return;
    }

    const query = QueryString.getQueryStringData();
    query.sort = value;

    await Thor.UserPreference.update(
      {},
      {
        data: {
          user_preferences: {
            questions_sort: value
          }
        }
      }
    );

    Turbolinks.visit(`${location.pathname}?${QueryString.parseQueryStringData(query)}`);
  }
}

(function () {
  'use strict';
  new QuestionSortInput();
})();
